import { __assign } from 'tslib';
import * as React from 'react';
import { useContext } from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, useUitkContext } from 'uitk-react-utils';
import { UitkRadioButtonGroupContext } from './uitk-radio-button-group-provider.esm.js';
import styles from './uitk-radio-button.css';
var getClassNameList = classNames.bind(styles);
var UitkRadioButton = function (props) {
  var _a, _b;
  var useReducedMotion = false;
  if (typeof window !== 'undefined') {
    useReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  var className = props.className,
    children = props.children,
    checked = props.checked,
    description = props.description,
    disabled = props.disabled,
    id = props.id,
    label = props.label,
    labelClassName = props.labelClassName,
    labelSuffix = props.labelSuffix,
    required = props.required,
    name = props.name,
    value = props.value,
    a11yLabel = props.a11yLabel,
    onChange = props.onChange;
  var RadioButtonGroupContext = useContext(UitkRadioButtonGroupContext);
  var baseCssClass = 'uitk-radio-button';
  var CssClassNameLabelSuffix = labelSuffix ? "".concat(baseCssClass, "-label-haslabelsuffix") : null;
  var wrapperClassNames = getClassNameList(baseCssClass, {
    'is-disabled': disabled
  });
  var labelCssClassNames = getClassNameList("uitk-radio-button-label", CssClassNameLabelSuffix, (_a = {}, _a[labelClassName] = Boolean(labelClassName), _a['is-required'] = required, _a));
  var inputClassNames = getClassNameList({
    checked: checked
  }, className);
  var contents = label || children;
  var checkedProp = (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.defaultChecked) ? 'defaultChecked' : 'checked';
  var isChecked = checked || (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.selected) === value;
  var controlClassNames = getClassNameList("".concat(baseCssClass, "-control"));
  var reducedMotionClassNames = getClassNameList("".concat(baseCssClass, "-has-reduced-motion"));
  var contextData = useUitkContext().data;
  var hasRequiredFieldIndicator = (contextData !== null && contextData !== void 0 ? contextData : {}).hasRequiredFieldIndicator;
  var randomId = Math.random().toString(36).substring(7);
  var uniqueDescriptionId = "radio-button-description-".concat(randomId);
  var a11yContent = a11yLabel !== null && a11yLabel !== void 0 ? a11yLabel : contents === null || contents === void 0 ? void 0 : contents.toString();
  var a11yFullLabel = labelSuffix ? "".concat(a11yContent, " ").concat(labelSuffix) : a11yContent;
  return React.createElement(UitkLayoutFlex, {
    className: wrapperClassNames,
    wrap: "nowrap"
  }, React.createElement(UitkLayoutFlexItem, {
    className: getClassNameList("".concat(baseCssClass, "-content")),
    grow: 1
  }, React.createElement("div", null, React.createElement("label", {
    className: labelCssClassNames,
    htmlFor: id
  }, React.createElement("input", __assign({
    type: "radio",
    name: name || (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.group),
    id: id
  }, (_b = {}, _b[checkedProp] = isChecked, _b), {
    className: inputClassNames,
    onChange: onChange || (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.onChange),
    value: value,
    disabled: disabled,
    "aria-label": a11yFullLabel,
    "aria-describedby": description ? uniqueDescriptionId : ''
  })), React.createElement("span", {
    "aria-hidden": "true",
    className: useReducedMotion ? "".concat(controlClassNames, " ").concat(reducedMotionClassNames) : controlClassNames
  }), React.createElement("span", {
    "aria-hidden": Boolean(a11yLabel),
    className: getClassNameList("".concat(baseCssClass, "-label-content"))
  }, contents, required && hasRequiredFieldIndicator && React.createElement("span", {
    className: "uitk-radio-button-required-asterisk",
    "aria-hidden": "true"
  }, ' ', "*")), labelSuffix && React.createElement("span", {
    "aria-hidden": Boolean(a11yLabel),
    className: getClassNameList("".concat(baseCssClass, "-label-suffix"))
  }, labelSuffix), a11yLabel && React.createElement("span", {
    className: "is-visually-hidden"
  }, a11yLabel), description && React.createElement("span", {
    className: getClassNameList("".concat(baseCssClass, "-description uitk-type-200")),
    id: uniqueDescriptionId
  }, description)))));
};
export { UitkRadioButton };